// generate=ts:EventTypeEnums
/** Valid agent event types */
export var AgentEventType;
(function (AgentEventType) {
    /** Match all agent event types */
    AgentEventType["all"] = "agent.*";
    /** Notification that agent has changed status to away */
    AgentEventType["away"] = "agent.away";
    /** Notification that agent has changed status to ready */
    AgentEventType["ready"] = "agent.ready";
    /** Notification that a session has been delivered to an agent */
    AgentEventType["sessionDelivered"] = "agent.sessionDelivered";
    /** Notification that a session has been offered to an agent */
    AgentEventType["sessionOffered"] = "agent.sessionOffered";
    /** Notification that a session has been rejected by an agent */
    AgentEventType["sessionRejected"] = "agent.sessionRejected";
    /** Notification that a session that had been offered to an agent has been rescinded */
    AgentEventType["sessionRescinded"] = "agent.sessionRescinded";
    /** Notification that a session has been terminated after being handled by the agent */
    AgentEventType["sessionTerminated"] = "agent.sessionTerminated";
    /** Synchronizing notification about current agent statistics and status */
    AgentEventType["status"] = "agent.status";
    /** Notification that agent wrap-up interval has completed */
    AgentEventType["wrapupCompleted"] = "agent.wrapupCompleted";
    /** Notification that agent wrap-up interval has started */
    AgentEventType["wrapupStarted"] = "agent.wrapupStarted";
})(AgentEventType || (AgentEventType = {}));
//# sourceMappingURL=agent-events.js.map